import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import AuthLayout from "../Layout/AuthLayout";
import {
  useAddAlertMutation,
  useGetJobAlertQuery,
  useRemoveAlertMutation,
} from "../Store/api/DataApi";
import { useNavigate } from "react-router-dom";
import AlertItemComponent from "../Components/jobAlert/AlertItemComponent";
import { error, success } from "../Services/CommonService";
import { useGetFilterOptionsQuery } from "../Store/api/CommonApi";
import Swal from "sweetalert2";
import { object, string, number, bool } from "yup";

let JobAlertSchema = object().shape({
  keyword: string().required({ keyword: "Keywords is required." }),
  experience: string().required({
    experience: "Experience is required.",
  }),
  job_types: string().required({
    job_types: "Job type is required.",
  }),
  schedule: string().required({
    schedule: "Schedule is required.",
  }),
});

export default function JobAlerts() {
  const formRef = useRef();
  const modalRef = useRef();
  const OptionApi = useGetFilterOptionsQuery();
  const { data, refetch } = useGetJobAlertQuery();
  const [addAlert] = useAddAlertMutation();
  const [removeAlert] = useRemoveAlertMutation();
  const [jobTypes, setJobTypesOption] = useState({});
  const navigate = useNavigate();
  const [errors, setError] = useState({});
  const [inputs, setInputs] = useState({
    keyword: "",
    experience: "",
    job_types: "",
    schedule: "",
  });

  const bootstrap = window.bootstrap;
  let model = null;

  const onOpenModal = useCallback(() => {
    const modalEle = modalRef.current;
    model = new bootstrap.Modal(modalEle, {
      backdrop: "static",
      keyboard: false,
    });
    model.show();
  }, [model]);

  const onCloseModal = useCallback(() => {
    model.hide();
  }, [model]);

  useEffect(() => {
    if (data?.error !== undefined && data?.error === "Invalid token!") {
      navigate("/logout");
    }
  }, [data, navigate]);

  const handleRemove = useCallback(
    (id) => {
      Swal.fire({
        text: "Do you want to remove job alert?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          removeAlert(id)
            .then((res) => {
              if (res.error) {
                error(res?.error?.data?.error);
              } else {
                refetch();
                onCloseModal();
                success(res?.data?.message);
              }
            })
            .catch((err) => {
              error(err?.error?.data?.error);
            });
        }
      });
    },
    [removeAlert, refetch, onCloseModal]
  );

  const addHandler = useCallback(
    (e) => {
      e.preventDefault();
      JobAlertSchema.validate(inputs, { strict: false, abortEarly: false })
        .then((resp) => {
          setError({});
          addAlert(resp)
            .then((res) => {
              if (res?.error !== undefined) {
                error(res?.error?.data?.error);
              } else {
                //e.target.reset();
                formRef.current.reset();
                refetch();
                onCloseModal();
                success(res?.data?.message);
              }
            })
            .catch((err) => {
              console.log(err);
              //error(err?.error?.data?.error);
            });
        })
        .catch((err) => {
          let errObj = {};
          err.errors.map((msg, i) => {
            let keys = Object.keys(msg);
            if (errObj[keys[0]] === undefined) {
              errObj = { ...errObj, [keys[0]]: msg[keys[0]] };
            }
            return false;
          });
          setError(errObj);
        });
    },
    [inputs, addAlert, onCloseModal, refetch]
  );

  useEffect(() => {
    if (OptionApi?.data) {
      setJobTypesOption(OptionApi?.data?.data?.job_types);
    }
  }, [OptionApi?.data, setJobTypesOption]);

  return (
    <Fragment>
      <PageBannerComponent title="Job Alerts" />
      <AuthLayout>
        {data?.data?.length <= 1 && (
          <div className="row mb-2">
            <div className="col text-right">
              <button className="btn btn-sm btn-success" onClick={onOpenModal}>
                Add Alert
              </button>
            </div>
          </div>
        )}
        <div className="job-alerts-item">
          <div className="alerts-list">
            <div className="row">
              <div className="col-md-4">
                <p>Keywords</p>
              </div>
              <div className="col-md-3">
                <p>Job Type</p>
              </div>
              <div className="col-md-2">
                <p>Experience</p>
              </div>
              <div className="col-md-2">
                <p>Frequency</p>
              </div>
              <div className="col-md-1"></div>
            </div>
          </div>
          {data?.data?.length > 0 ? (
            data?.data?.map((jalert, i) => (
              <AlertItemComponent
                item={jalert}
                key={i}
                handleRemove={handleRemove}
                jobTypes={jobTypes}
              />
            ))
          ) : (
            <div className="row">
              <div className="col text-center mt-3">No Alert found</div>
            </div>
          )}
          {/* <div className="alerts-content">
            <div className="row">
              <div className="col-md-3">
                <h3>Web Designer</h3>
                <span className="location">
                  <i className="fa fa-location-arrow" /> Manhattan, NYC
                </span>{" "}
              </div>
              <div className="col-md-3">
                <p>Web Designer</p>
              </div>
              <div className="col-md-3">
                <p>
                  <span className="full-time">Full-Time</span>
                </p>
              </div>
              <div className="col-md-3">
                <p>Daily</p>
              </div>
            </div>
          </div>
          <div className="alerts-content">
            <div className="row">
              <div className="col-md-3">
                <h3>UI/UX designer</h3>
                <span className="location">
                  <i className="fa fa-location-arrow" /> Manhattan, NYC
                </span>{" "}
              </div>
              <div className="col-md-3">
                <p>UI/UX designer</p>
              </div>
              <div className="col-md-3">
                <p>
                  <span className="full-time">Full-Time</span>
                </p>
              </div>
              <div className="col-md-3">
                <p>Daily</p>
              </div>
            </div>
          </div>
          <div className="alerts-content">
            <div className="row">
              <div className="col-md-3">
                <h3>Developer</h3>
                <span className="location">
                  <i className="fa fa-location-arrow" /> Manhattan, NYC
                </span>{" "}
              </div>
              <div className="col-md-3">
                <p>Developer</p>
              </div>
              <div className="col-md-3">
                <p>
                  <span className="part-time">Part-Time</span>
                </p>
              </div>
              <div className="col-md-3">
                <p>Daily</p>
              </div>
            </div>
          </div>
          <div className="alerts-content">
            <div className="row">
              <div className="col-md-3">
                <h3>Senior UX Designer</h3>
                <span className="location">
                  <i className="fa fa-location-arrow" /> Manhattan, NYC
                </span>{" "}
              </div>
              <div className="col-md-3">
                <p>Senior UX Designer</p>
              </div>
              <div className="col-md-3">
                <p>
                  <span className="full-time">Full-Time</span>
                </p>
              </div>
              <div className="col-md-3">
                <p>Daily</p>
              </div>
            </div>
          </div> */}
        </div>
      </AuthLayout>
      <div
        className="modal fade"
        ref={modalRef}
        id="staticBackdrop"
        data-bs-backdrop="static"
        backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                New message
              </h5>
              <button
                type="button"
                className="btn-close bg-transparent border-0"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={onCloseModal}
              >
                X
              </button>
            </div>
            <form ref={formRef} onSubmit={addHandler}>
              <div className="modal-body p-4">
                <div className="mb-3">
                  <label htmlFor="recipient-name" className="col-form-label">
                    Keywords:
                    <br />
                    <sub>
                      Add comma saparate keywords like (web development,
                      react...).
                    </sub>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) =>
                      setInputs({
                        ...inputs,
                        keyword: e.target.value,
                      })
                    }
                    required
                  />
                  {errors?.keyword !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.keyword}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label htmlFor="message-text" className="col-form-label">
                    Job Type:
                  </label>
                  <select
                    className="form-control"
                    defaultValue={""}
                    onChange={(e) =>
                      setInputs({
                        ...inputs,
                        job_types: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="" hidden>
                      Select Job Type
                    </option>
                    {Object.keys(jobTypes).length > 0 &&
                      Object.keys(jobTypes).map((type, i) => {
                        return (
                          <option value={type} key={i}>
                            {jobTypes[type]}
                          </option>
                        );
                      })}
                  </select>
                  {errors?.job_types !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.job_types}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label htmlFor="message-text" className="col-form-label">
                    Experience:
                  </label>
                  <select
                    className="form-control"
                    defaultValue={""}
                    onChange={(e) =>
                      setInputs({
                        ...inputs,
                        experience: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="" hidden>
                      Select Experience
                    </option>
                    <option value="1">1 Year</option>
                    <option value="2">2 Years</option>
                    <option value="3">3 Years</option>
                    <option value="4">4 Years</option>
                    <option value="5">5 Years</option>
                    <option value="6">6 Years</option>
                    <option value="7">7 Years</option>
                    <option value="8">8 Years</option>
                    <option value="9">9 Years</option>
                    <option value="10">10 Years</option>
                  </select>
                  {errors?.experience !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.experience}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label htmlFor="message-text" className="col-form-label">
                    Schedule:
                  </label>
                  <select
                    className="form-control"
                    defaultValue={""}
                    onChange={(e) =>
                      setInputs({
                        ...inputs,
                        schedule: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="" hidden>
                      Select Schedule
                    </option>
                    <option value="1">Daily</option>
                    <option value="2">Weekly</option>
                    <option value="3">Monthly</option>
                  </select>
                  {errors?.schedule !== undefined && (
                    <div className="invalid-feedback d-block">
                      {errors?.schedule}
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={onCloseModal}
                >
                  Close
                </button>
                <button
                  type="button"
                  onClick={addHandler}
                  className="btn btn-primary"
                >
                  Set Alert
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
